/*!
 * pmk167
 * (c) 2019 kirsites <kirsites@gmail.com>
 * licensed under the MIT license
 */

(function () {

    let isMenuOpen = false;

    $('.hamburger').on('click', function () {
        isMenuOpen = !isMenuOpen;
        $('body').toggleClass('isMenuOpen', isMenuOpen);
    });

    $('.mainmenu__link').on('click', function (e) {
        const $inner = $(this).parent().find('.mainmenu-inner');

        console.log($inner.length);
        if ($inner.length) {
            e.preventDefault();
            $(this).parent().toggleClass('childrenOpen');
        }
    });

})();
